<template>
  <section>
    <b-overlay :show="busy" rounded="sm">
      <b-input v-model="filter" class="mb-2" placeholder="Filter surveys..."></b-input>
      <b-table
        id="user-survey-table"
        :busy.sync="busy"
        :current-page="currentPage"
        :fields="fields"
        :filter="filter"
        :items="surveys"
        :per-page="perPage"
        bordered
        empty-filtered-text="No surveys found matching this filter."
        head-variant="dark"
        hover
        responsive="sm"
        show-empty
        small
        stacked="sm"
        striped
        @filtered="onFiltered"
      >
        <template #table-caption
          >{{ userSurveys.length }} / {{ surveys.length }} surveys assigned
        </template>
        <template #cell(status)="data">
          <b-form-checkbox
            :id="data.item.id"
            v-model="data.item.status"
            :name="data.item.id"
            @change="onUpdate(data.item)"
          >
          </b-form-checkbox>
        </template>
      </b-table>

      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="rows"
        align="center"
        aria-controls="user-survey-table"
        pills
        size="sm"
      ></b-pagination>
    </b-overlay>
  </section>
</template>

<script>
  export default {
    name: 'UserSurveyForm',
    props: { surveys: Array, busy: Boolean, userSurveys: Array },
    data() {
      return {
        selected: [],
        fields: [
          'event_name',
          {
            key: 'status',
            label: 'Assigned',
            sortable: true,
          },
        ],
        filter: '',
        currentPage: 1,
        perPage: 10,
        rows: 0,
      };
    },
    created() {
      this.rows = this.surveys.length;
    },
    methods: {
      surveysUpdated(event) {
        this.$emit('surveysUpdated', event);
      },
      onFiltered(filteredItems) {
        this.rows = filteredItems.length;
      },
      onUpdate(event) {
        this.$emit('surveyUpdated', event);
      },
    },
  };
</script>
